import React from "react";
import Title from "../../../components/Title/Title";
import './RegistrationPage.scss';

const Registration2026page = () => {
    return (
        <div>
            <Title>Venue and Registration</Title>
            <p>
                TBD
            </p>
        </div>
    )
}

export default Registration2026page

